const customerTypes = {
  data() {
    return {
      _customerTypes: null
    }
  },
  methods: {
    async buildCustomerTypes() {
      if (!this._customerTypes) {
        let provincialCustomerTypes;
        try {
          provincialCustomerTypes = await (await import(`@/views/provinces/${this.$store.getters.company.province}/sales/customerTypes`)).customerTypes();
        } catch(error) {
          provincialCustomerTypes = [{header:this.$store.getters.company.province},{text:'Licensee',value:'Licensee',spirit:false,wine:false,prefInBond:false},{text:'Contract',value:'Contract',spirit:false,wine:false,prefInBond:true}];
        }
        this._customerTypes =  [{text:'none',value:'None',spirit:false,wine:false},
                                {divider:true},
                                {header:'EXCISE'},
                                {text:'Spirits licensee',value:'SpiritsLicense',spirit:true,wine:false,prefInBond:true,prefCases:true},
                                {text:'Excise warehouse',value:'ExciseWarehouse',spirit:false,wine:false,prefInBond:true,prefCases:true},
                                {text:'Licensed user',value:'LicensedUser',spirit:true,wine:false,prefInBond:true,prefCases:true},
                                {text:'Wine licensee',value:'WineLicensee',spirit:false,wine:true,prefInBond:false,prefCases:true},
                                {divider:true},
                                {text:'Export',value:'Export',spirit:true,wine:false,prefInBond:true,prefCases:true},
                                {text:'Duty free',value:'DutyFree',spirit:false,wine:false,prefInBond:true,prefCases:true},
                                {text:'Registered user',value:'RegisteredUser',spirit:false,wine:false,prefInBond:true,prefCases:false},
                                {text:'Accredited representative',value:'AccreditedRepresentative',spirit:false,wine:false,prefInBond:true,prefCases:false},
                                {text:'Ships store',value:'ShipsStore',spirit:false,wine:false,prefInBond:true,prefCases:true},
                                {divider:true},
                                ...provincialCustomerTypes];
      }
      return this._customerTypes;
    }
  }
}

export default customerTypes;